export var SlateEditable;
(function (SlateEditable) {
    SlateEditable["ADD_COMPONENT"] = "addComponent";
    SlateEditable["ALL"] = "all";
    SlateEditable["EDIT_COMPONENT"] = "editComponent";
    SlateEditable["NONE"] = "none";
})(SlateEditable || (SlateEditable = {}));
//# sourceMappingURL=slate-editable.enum.js.map